export default function (context) {
	// If the player is not authenticated
	if (context.$cookie.get('token')) {
		return context.redirect('/')
	}
}
